/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_TriggerInputs */

const tr_landing_pricerules_mock_bot_trigger = /** @type {(inputs: Landing_Pricerules_Mock_Bot_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD tetiklendi`)
};

const en_landing_pricerules_mock_bot_trigger = /** @type {(inputs: Landing_Pricerules_Mock_Bot_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD triggered`)
};

const de_landing_pricerules_mock_bot_trigger = /** @type {(inputs: Landing_Pricerules_Mock_Bot_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD ausgelöst`)
};

const ru_landing_pricerules_mock_bot_trigger = /** @type {(inputs: Landing_Pricerules_Mock_Bot_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сработал триггер USD`)
};

/**
* | output |
* | --- |
* | "USD triggered" |
*
* @param {Landing_Pricerules_Mock_Bot_TriggerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_trigger = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_TriggerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_TriggerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_trigger(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_trigger(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_trigger(inputs)
	return tr_landing_pricerules_mock_bot_trigger(inputs)
});